import { Outlet, createFileRoute } from '@tanstack/react-router'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Layout route para /dashboard/$dashboardId/sites
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites',
)({
  component: function SitesLayout() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.SITE} dashboardId={dashboardId}>
        <Outlet />
      </RequireModule>
    )
  },
})
